module.exports = __webpack_public_path__ + "static/img/gzhDown.cc2874f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gzhDown.png
// module id = suKD
// module chunks = 2